
import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import TahsilatForm from "@/components/forms/TahsilatForm.vue";
import DeleteDialog from "@/components/dialogs/DeleteDialog.vue";
import {TahsilatEntity} from "@/entity/TahsilatEntity";
import TaksitlendirmeForm from "@/components/anakart/taksitlendirme/TaksitlendirmeForm.vue";
import FormDialog from "@/components/dialogs/FormDialog.vue";
import {TakipEntity} from "@/entity/TakipEntity";
import {TakipTalebiEntity} from "@/entity/TakipTalebiEntity";
import {AlacakEntity} from "@/entity/AlacakBelgeler/AlacakEntity";
import AlacakKalemiEntity from "@/entity/AlacakBelgeler/AlacakKalemiEntity";
import {ParaBirimi} from "@/enum/ParaBirimi";
import FormWrapper from "@/components/FormWrapper.vue";
import TahsilatMakbuzuTaslak from "@/components/TahsilatMakbuzuTaslak.vue";
import {TahsilatTuruLabel} from "@/enum/TahsilatTuru";
import TaksitlendirmeList from "@/components/lists/TaksitlendirmeList.vue";
import TaksitTaahutList from "@/components/lists/TaksitTaahutList.vue";
import {DovizTakipSekli} from "@/enum/DovizTakipSekli";

@Component({
  components: {
    TaksitTaahutList,
    TaksitlendirmeList,
    TahsilatMakbuzuTaslak, FormWrapper, FormDialog, TaksitlendirmeForm, DeleteDialog, TahsilatForm},
  methods: {
    getTahsilatTuruLabel(turu: string): string {
      return TahsilatTuruLabel[turu as keyof typeof TahsilatTuruLabel] || '';
    }
  }
})
export default class TahsilatList extends Vue {
  @Prop() takip!: TakipEntity;
  @Prop() genelToplam!: number;
  loading=false;
  tahsilatTuruLabel = TahsilatTuruLabel
  paraBirimi = ParaBirimi;
  expanded: number = 0;
  odemeTaksitDetaylari:any=[]
  taksitVarMi = false;
  headers = [
    {text: "Sıra No", align: "start", sortable: true, value: "index", width: 30},
    {text: "Borçlu", align: "start", sortable: false, value: "borclu"},
    {text: "Tahsilat Türü", value: "tahsilat_turu"},
    {text: "Tahsilat Tarihi", value: "tarih"},
    {text: "Yatırılan Tutar", value: "tutar", width: 125},
    {text: "Tahsil Harcı", value: "tahsil_harci", width: 125},
    {text: "Cezaevi Harcı", value: "cezaevi_harci", width: 125},
    {text: "Net Tutar", align: "right", value: "net_tutar", width: 125},
    {text: "İşlemler", align: "center", value: "actions", sortable: false, width: 150}
  ];
  tahsilatTutarlari: TahsilatTutarlari = new TahsilatTutarlari();
  DovizTakipSekli = DovizTakipSekli
  dovizAlacakTaksit = false
  dovizAlacakUyari = false

  getDovizAlacakMi(){
    this.takip.talepler[0].alacaklar.forEach((doviz: any) => {
      if (doviz.doviz_kur_tarihi==this.DovizTakipSekli.tahsilat){
        this.dovizAlacakUyari = true
        this.dovizAlacakTaksit = false;
      }else{
        this.dovizAlacakUyari = false
        this.dovizAlacakTaksit = true;
      }
    })
  }

  get defaultTahsilat(){
    let tahsilatObj = new TahsilatEntity();
    return tahsilatObj;
  }

  get tahsilatStats() {
    return [
      {icon: 'mdi-cash-multiple', title: 'Toplam Tahsilat Tutarı', value: this.$helper.tutarStr(this.tahsilatTutarlari.toplamTahsilat)},
      {icon: 'mdi-gavel', title: 'Ödenen Cezaevi Harcı Toplamı', value: this.$helper.tutarStr(this.tahsilatTutarlari.cezaeviHarci)},
      {icon: 'mdi-receipt-text-outline', title: 'Ödenen Toplam Harç Tutarı', value: this.$helper.tutarStr(this.tahsilatTutarlari.toplamHarc)},
      {icon: 'mdi-cash-check', title: 'Toplam Net Tahsilat Tutarı', value: this.$helper.tutarStr(this.tahsilatTutarlari.toplamNetTahsilat)},
      {icon: 'mdi-calendar-arrow-left', title: 'Takip Öncesi Tahsilat Tutarı', value: this.$helper.tutarStr(this.tahsilatTutarlari.takipOncesiTahsilat)},
      {icon: 'mdi-calendar-arrow-right', title: 'Takip Sonrası Tahsilat Toplamı', value: this.$helper.tutarStr(this.tahsilatTutarlari.takipSonrasiTahsilat)},
      {icon: 'mdi-handshake-outline', title: 'Taahhüt Toplamı', value: this.$helper.tutarStr(this.tahsilatTutarlari.taahhut), highlight: true},
    ];
  }

  handleTaksitler(){
    this.$http.get('/api/v1/takip/' + this.$route.params.id + '/taksit').then((response) => {
      this.odemeTaksitDetaylari = response.data;
    })
  }

  mounted() {
    this.calculate();
    this.handleTaksitler();
    this.getDovizAlacakMi()
  }

  @Watch("takip.tahsilatlar", {deep: true})
  onItemsChange() {
    this.calculate();
  }

  load() {
    this.$emit('load');
  }


  calculate() {
    this.tahsilatTutarlari = new TahsilatTutarlari();

    this.takip.tahsilatlar.forEach((tahsilat: TahsilatEntity) => {
      if (tahsilat.tarih && tahsilat.tutar) {
        let tutar = tahsilat.para_birimi_id === ParaBirimi.TRY ? Number(tahsilat.tutar) : Number(tahsilat.tutar) * Number(tahsilat.kur);
        let cezaeviHarci = Number(tahsilat.para_birimi_id == ParaBirimi.TRY ? tahsilat.cezaevi_harci : tahsilat.cezaevi_harci * tahsilat.kur);
        let tahsilHarci = Number(tahsilat.para_birimi_id == ParaBirimi.TRY ? tahsilat.tahsil_harci : tahsilat.tahsil_harci * tahsilat.kur);

        if (!this.takip.takip_tarihi || tahsilat.tarih < this.takip.takip_tarihi) {
          this.tahsilatTutarlari.takipOncesiTahsilat += tutar;
        } else {
          this.tahsilatTutarlari.takipSonrasiTahsilat += tutar;
        }

        this.tahsilatTutarlari.cezaeviHarci += cezaeviHarci;
        this.tahsilatTutarlari.tahsilHarci += tahsilHarci;
      }
    });
    this.tahsilatTutarlari.takipToplami = this.calculatetakipToplami();
  }

  calculatetakipToplami(): number {
    let tutar = 0;
    this.takip.talepler.forEach((talep: TakipTalebiEntity) => {
      talep.alacaklar.forEach((alacak: AlacakEntity) => {
        alacak.alacak_kalemleri.forEach((alacakKalemi: AlacakKalemiEntity) => {
          if (!this.takip.takip_tarihi || alacakKalemi.vade_tarihi <= this.takip.takip_tarihi)
            tutar += Number(alacakKalemi.para_birimi_id == ParaBirimi.TRY ? alacakKalemi.tutar : alacakKalemi.tutar * alacakKalemi.kur);
        });
      });
    });
    return tutar;
  }
}

class TahsilatTutarlari {
  takipToplami: number = 0;
  takipOncesiTahsilat: number = 0;
  takipSonrasiTahsilat: number = 0;
  taahhut: number = 0;
  tahsilHarci: number = 0;
  cezaeviHarci: number = 0;

  get toplamTahsilat() {
    return Number(this.takipOncesiTahsilat) + Number(this.takipSonrasiTahsilat);
  }

  get toplamHarc() {
    return Number(this.tahsilHarci) + Number(this.cezaeviHarci);
  }

  get toplamNetTahsilat(): number {
    return this.toplamTahsilat - this.toplamHarc;
  }

  get kalanTahsilHarciTutari(): number {
    return this.takipToplami * 0.0455 - this.tahsilHarci;
  }

}
